/* eslint-disable prefer-template */
/* eslint-disable default-param-last */
import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
  policies: [],
  data: [],
  totalRecord: 0,
  more: false,
  responseTime: 0,
  isLoading: false,
  isError: false,
  msgError: '',
};
export const attendanceTimeoffReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionType.API_ATTENDANCE_TIMEOFF_POLICIES + '_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case actionType.API_ATTENDANCE_TIMEOFF_POLICIES + '_RESULT':
      return {
        ...state,
        policies: action.result.data,
        responseTime: action.result.responseTime,
      };
    case actionType.API_ATTENDANCE_TIMEOFF_POLICIES + '_FAILED':
      return {
        ...state,
        isError: true,
        msgError: action.err,
        isLoading: false,
      };
    case actionType.API_ATTENDANCE_TIMEOFF + '_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case actionType.API_ATTENDANCE_TIMEOFF + '_RESULT':
      return {
        ...state,
        data: action.result.data.data,
        totalRecord: action.result.data?.total_data,
        isLoading: false,
        isError: false,
        msgError: '',
      };
    case actionType.API_ATTENDANCE_TIMEOFF + '_RESET':
      return {
        ...state,
        data: action.result.data.data,
        totalRecord: action.result.data?.total_data,
        isLoading: false,
        isError: false,
        msgError: '',
      };
    case actionType.API_ATTENDANCE_TIMEOFF + '_FAILED':
      return {
        ...state,
        isError: true,
        msgError: action.err,
        isLoading: false,
        status: action.err?.response?.status
      };
    default:
      return state;
  }
};
